<template>

  <div class="gameplay_bg" >
<navigation-header></navigation-header>
    <div>
            <div class="container">

              <div class="game_content no_cat free_game">
                <div class="frame"></div>
                <img src="/static/images/quotes.png" class="quotes_img">
                <div class="game_desc_txt">{{questionText}}</div>
                <img src="/static/images/shadow_1.png" class="shadow_img">
                <div class="flex_row icons">
                  <p class="correct_ans no_icon" ref="noButton">{{ getTranslations.visitor_free_trial_question0_answer2 }}</p>
                  <img src="/static/images/swipe_artwork.png">
                  <p class="wrong_ans yes_icon" ref="yesButton">{{ getTranslations.visitor_free_trial_question0_answer1 }}</p>
                </div>
              </div>

    </div>

    <div class="gameplay_footer footer_fixed">
      <p> {{ getTranslations.visitor_free_trial_modals_play_more }} </p>
    </div>

    </div>
    <component :is="componentModalAnswer" />

  </div>

</template>


<script>

/* eslint no-console: "off" */
/* eslint-disable */

import { mapState, mapGetters, mapMutations } from 'vuex';
import { Howl } from 'howler';
import { GameMixin, GameMixin2 } from '@/common/mixins/game';
import Timer from "../../home/game/Timer";
import WrongAnswer from './modals/WrongAnswer';
import Winner from './modals/Winner';
import CorrectAnswer from './modals/CorrectAnswer';
import { handleBurger, handleLanguageDropdown, openCloseTab } from '@/common/jQuery';
import NavigationHeader from "../../../../../ui-src-swipo/src/components/visitor/Visitor";


const moment = require('moment');
const ProgressBar = require('progressbar.js');


export default {
  name: 'gameFreePlay',
  components: {NavigationHeader, Timer },
  mixins: [GameMixin, GameMixin2],
  data() {
    return {
      componentModalAnswer: null,
      userHasAnswer: false,
      cssChange: false,
      questionText: null,
      curQuestionNumber: 0,
      answerDTOList: {
        0: 'YES',
        1: 'NO',
        2: 'YES',
      },
      questionsData: {
        homeUserDetails: {
          score: 0,
          roundDTOList: {
            isWinner: false,
          },
        },
      },
      randomizedAnswers: [],
      playerAnswered: false,
      playerAnswerID: '',
      playerAnswerKey: '',
      currentQuestionID: 0,
      questionAnswerTime: 10, // seconds
      secondsElapsed: 0,
      svgTimerCSSClass: '',
      svgTimerPathsCSSClasses: [],
      timer: null,
      // TODO implement playing of all sounds
      selectSound: new Howl({
        src: ['/static/sounds/Select_Answer.ogg', '/static/sounds/Select_Answer.mp3'],
      }),
      rightAnswerSound: new Howl({
        src: ['/static/sounds/right_answer.ogg', '/static/sounds/right_answer.mp3'],
      }),
      wrongAnswerSound: new Howl({
        src: ['/static/sounds/wrong_answer.ogg', '/static/sounds/wrong_answer.mp3'],
      }),
      countDownTimerSound: new Howl({
        src: ['/static/sounds/CountDownTimer.ogg', '/static/sounds/CountDownTimer.mp3'],
      }),
    };
  },
  created() {
    console.log('in free trial Game created hook');
    this.initQuestionData();
  },
  mounted() {
    console.log(this.getDisplayedLocale);
    this.$nextTick(() => {
      handleLanguageDropdown();
      handleBurger();
      this.timer = setInterval(() => {
        if (this.$refs.noButton.classList.contains('game_correct') || this.$refs.yesButton.classList.contains('game_correct')) {
          this.$refs.noButton.classList.remove('game_correct');
          this.$refs.yesButton.classList.remove('game_correct');
        }
        if (this.$refs.noButton.classList.contains('check')) {
          this.$refs.noButton.classList.remove('check');
          if (this.answerDTOList[this.currentQuestionID] === 'NO') {
            this.currentQuestionID += 1;
            this.$refs.noButton.classList.add('game_correct');
            this.rightAnswerSound.play();
            this.updateQuestionText(this.currentQuestionID);
          } else {
            this.$refs.noButton.classList.add('game_wrong');
            this.wrongAnswerSound.play();
            this.userHasAnswer = true;
            this.componentModalAnswer = WrongAnswer;
            clearInterval(this.timer);
            this.showModal();
          }
        } else if (this.$refs.yesButton.classList.contains('check')) {
          this.$refs.yesButton.classList.remove('check');
          if (this.answerDTOList[this.currentQuestionID] === 'YES') {
            this.currentQuestionID += 1;
            this.$refs.yesButton.classList.add('game_correct');
            this.rightAnswerSound.play();
            this.updateQuestionText(this.currentQuestionID);
          } else {
            this.$refs.yesButton.classList.add('game_wrong');
            this.wrongAnswerSound.play();
            this.userHasAnswer = true;
            this.componentModalAnswer = WrongAnswer;
            clearInterval(this.timer);
            this.showModal();
          }
        }
        if (this.currentQuestionID === 3) {
          this.rightAnswerSound.play();
          this.questionText = null;
          this.userHasAnswer = true;
          if (this.freeTrialGuaranteedPrize) {
            this.componentModalAnswer = Winner;
          } else {
            this.componentModalAnswer = CorrectAnswer;
          }
          clearInterval(this.timer);
          this.showModal();
        }

      }, 500);
    });
    this.$nextTick(() => {
      // PLAY FUNCTIONALITY
      let imgCount = 0;
      const cloudUrl = '/static/images/images_questions/';
      const data = [
        { img: `${cloudUrl}0001.jpg` },
        { img: `${cloudUrl}0003.jpg` },
        { img: `${cloudUrl}0002.jpg` },
      ];
      const frame = document.body.querySelector('.frame');
      data.forEach(_data => appendCard(_data));

      let current = frame.querySelector('.card:last-child');
      let likeText = current.children[0];
      let startX = 0, startY = 0, moveX = 0, moveY = 0;
      initCard(current);

      // document.querySelector('.wrong_ans').onclick = () => {
      $('.wrong_ans').click(function() {
        moveX = 1;
        moveY = 0;
        complete();
        $(this).addClass('check');
      });
      // document.querySelector('.correct_ans').onclick = () => {
      $('.correct_ans').click(function() {
        this.componentModalAnswer = CorrectAnswer;
        moveX = -1;
        moveY = 0;
        complete();
        $(this).addClass('check');
      });

      function appendCard(data) {
        const firstCard = frame.children[0];
        const newCard = document.createElement('div');
        newCard.className = 'card'
        newCard.style.backgroundImage = `url(${data.img})`;
        newCard.innerHTML = `
                    <div class="bottom">
                    </div>
                    `;
        if (firstCard) frame.insertBefore(newCard, firstCard);
        else frame.appendChild(newCard);
        imgCount++;
      }

      function initCard(card) {
        card.addEventListener('pointerdown', onPointerDown);
      }

      function setTransform(x, y, deg, duration) {

        current.style.transform = `translate3d(${x}px, ${y}px, 0) rotate(${deg}deg)`;
        likeText.style.opacity = Math.abs(((x / innerWidth) * 2.1));
        // likeText.className = `is-like ${x > 0 ? 'like' : 'nope'}`
        // likeText.className = `is-like ${x > 0 ? audio2.play() : audio3.play()}`
        if (duration) current.style.transition = `transform ${duration}ms`;

      }



      function onPointerDown({ clientX, clientY }) {
        startX = clientX;
        startY = clientY;
        current.addEventListener('pointermove', onPointerMove);
        current.addEventListener('pointerup', onPointerUp);
        current.addEventListener('pointerleave', onPointerUp);
      }


      function onPointerMove({ clientX, clientY }) {
        moveX = clientX - startX;
        moveY = clientY - startY;

        setTransform(moveX, moveY, (moveX / innerWidth) * 50);

      }
      function onPointerUp() {
        current.removeEventListener('pointermove', onPointerMove);
        current.removeEventListener('pointerup', onPointerUp);
        current.removeEventListener('pointerleave', onPointerUp);
        if (Math.abs(moveX) > frame.clientWidth / 2) {
          current.removeEventListener('pointerdown', onPointerDown);
          complete();
        } else cancel();
      }

      function complete() {
        const flyX = (Math.abs(moveX) / moveX) * innerWidth * 1.3;
        const flyY = (moveY / moveX) * flyX;
        setTransform(flyX, flyY, flyX / innerWidth * 50, innerWidth);

        if (flyX < 0) {
          $('.correct_ans').addClass('check');
        } else if (flyX > 0) {
          $('.wrong_ans').addClass('check');
        }

        const prev = current;
        const next = current.previousElementSibling;
        if (next) initCard(next);
        current = next;
        likeText = current.children[0];
        appendCard(data[imgCount % 4]);
        setTimeout(() => frame.removeChild(prev), innerWidth);
      }
      function cancel() {
        setTransform(0, 0, 0, 100);
        setTimeout(() => current.style.transition = '', 100);
      }
    });
    openCloseTab();
  },
  beforeDestroy() {
    console.log('in free trial game\'s beforeDestroy hook');
    clearInterval(this.timer);
  },
  methods: {
    ...mapMutations('game', [
      'setCurrentRoundNumber',
      'setCurrentQuestionNumber',
      'resetPlayersAnswersHistoryCSSClasses',
      'setHomePlayerRoundAnswerTime',
      'setCurrentRoundWinner',
      'setGameFinishedStatus',
      'setGameWinner',
    ]),
    ...mapMutations('common', [
      'validTransitionForFreeGameMethod',
      'setFreeUserPrice',
    ]),
    updateQuestionText(key) {
      this.questionText = this.getTranslations[`visitor_free_trial_question${key}`];
    },
    increaseCurrentQuestionNumberByOne() {
      const question = Math.floor(Math.random() * ((3 - 1) + 1)) + 1;
      console.log(`given Question ${question} ...`);
      this.curQuestionNumber = question;
    },
    initQuestionData() {
      console.log('initializing question data...');
      this.updateQuestionText(this.currentQuestionID);
      this.initCommonData();
      // this.initAndStartTimerTrial();
    },
    initCommonData() {
      this.playerAnswered = false;
      this.playerAnswerKey = '';
    },
    initAndStartTimerTrial() {
      this.$nextTick(() => {
        this.timer = setInterval(() => {
          if (this.userHasAnswer) {
            clearInterval(this.timer);
          }

          this.secondsElapsed += 1;
          if (this.secondsElapsed === this.questionAnswerTime) {
            this.checkForUserAnswer();
            clearInterval(this.timer);
          }
        }, 1000);
      });
      /* eslint-enable */
    },
    checkForUserAnswer() {
      if (!this.userHasAnswer) {
        console.log('User didnt answer');
        this.registerUserAnswer(1, 1);
      }
    },
    registerUserAnswer(answerID, answerKey) {
      this.validTransitionForFreeGameMethod(false);
      if (!this.userHasAnswer) {
        this.userHasAnswer = true;
        console.log(`Unsub user has answered with answer ${answerKey}...`);
        console.log(this.freeTrialGuaranteedPrize);
        if (!this.playerAnswered && this.curQuestionNumber <= 3) {
          if (answerKey === 4) {
            console.log('Unsub user has won!!!');
            this.rightAnswerSound.play();
            this.questionsData.homeUserDetails.roundDTOList.isWinner = true;
            setTimeout(() => {
              this.normalTransition = true;
              if (this.freeTrialGuaranteedPrize) {
                this.componentModalAnswer = Winner;
              }
              this.componentModalAnswer = CorrectAnswer;
              this.showModal();
            }, 2000);
          } else {
            setTimeout(() => {
            }, 1000);
            this.wrongAnswerSound.play();
            console.log('Unsub user has lost!!!');
            this.questionsData.homeUserDetails.roundDTOList.isWinner = false;
            setTimeout(() => {
              this.normalTransition = true;
              this.componentModalAnswer = WrongAnswer;
              this.showModal();
            }, 2000);
          }
        }
        clearInterval(this.timer);
        setTimeout(() => {
          this.normalTransition = true;
        }, 5000);


        this.questionsData.homeUserDetails.roundDTOList.totalAnswerTimeMillis = this.secondsElapsed * 1000;
        clearInterval(this.timer);
      }
    },
    getActiveTabLocale(key) {
      return this.getLocale === key ? 'active' : '';
    },
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        // show/hide modal
        $('.modal-close, .modal-overlay,.btn_close, .overlay').click(() => {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $("#wheel_prize_modal").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          this.$router.push('/');
        });
      });
      /* eslint-enable */
    },
    getActiveTabClass(path) {
      this.normalTransition = true;
      return this.currentTabPath === path ? 'active' : '';
    },
    changeLanguage(newValue) {
      console.log(`New Language ${newValue}`);
      this.setUserLanguage(newValue);
      localStorage.setItem('locale', newValue);
      this.setLocale({ currentLocale: newValue });
      this.getTranslationsFile().then(() => {
        moment.locale(this.getLocale.toLowerCase());
        this.storeVisitorWinners(localStorage.getItem('locale')).then(() => {
          this.storeAvailablePrizeTypes(localStorage.getItem('locale')).then(() => {
            this.facebookSDKApi().then(() => {
              this.changeCSSFile();
            });
          });
        });
      });
    },
    getHomePlayerAnswersHistory(answerIndex) {
      const homePlayerAnswersHistory = this.homePlayerCorrectAnswersCSSClasses[answerIndex];
      return homePlayerAnswersHistory !== undefined ? homePlayerAnswersHistory : '';
    },
  },
  computed: {
    ...mapState('i18n', [
      'availableLocales',
    ]),
    ...mapState('common', [
      'freeTrialGuaranteedPrize',
      'userDetails',
      'freeTrialPoints',
      'hideLangSelection',
      'soundsOn',
      'freeUserPrice',
    ]),
    ...mapState('game', [
      'playersDetails',
      'currentRoundNumber',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
      'getDisplayedLocale',
      'getTranslationByOperator',
    ]),
    getThemeColor() {
      return {
        borderColor: `rgb(${this.homePlayerCurrentSelectedTheme.red},${this.homePlayerCurrentSelectedTheme.green},${this.homePlayerCurrentSelectedTheme.blue})`,
      };
    },
  },
};
/* eslint-enable */
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/GameFreePlay.vue